// import {state} from '@remote/pan/store/index';
import { SSO } from '@xbase/sso'
import config from '../xbase-sdk.config'

const sso = process.client ? new SSO(config) : {}

// 展示登录弹窗需要配置额外的参数
export const ssoIframe = process.client
  ? new SSO({
    ...config,
    authenticatePage: 'https://i.xunlei.com/xluser/auth/',
    iFrame: {
      switch: 'on',
      showType: 'embed',
      container: document.getElementById('login-wrap'),
    },
  })
  : {}

export default sso
export function pubBaBWF1Dx06SHRJBeh0k2Z09xPEVPj3Jn (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./captcha.js').pub7yhziBOeyyHYURXoeFDV4Y39iXDE9sEC
            const nextPart2 = require('./util.js').pubiZphO2j0gQ2gX7qWD63S8AmuDtHBF3ro
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubbcOi40TICOq8wXbmyJwkDLWk5kFSXfKg (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'zwLP+qX+YkgPPlELZW3YexB', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./stat.js').pubI2JBTL8drmLJkKJeiAATQ0X2bN2cVJmn
              return nextPart1(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }